import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IonContent } from '@ionic/react';

import { screen } from '$components/hoc';
import Header from '$components/header';

import { IonPageWrapper } from './styles';
import { factoryActions } from '$fbusiness/redux/factory';
import { TableView2 } from '$gcomponents/widgets';
import { COUPON_TABLE, COUPON_TABLE_CONFIG } from './couponTable';
import CouponModel, { initialCoupon } from '$fbusiness/models/coupon';
import CouponEditModal from './couponEditModal';
import FabButton from '$fcomponents/fabButton';
import ItemActionModel from '$gbusiness/models/itemAction';
import { accessHide, getAccess, isAccessible } from '$fbusiness/helpers/util';
import { dialog } from '$gcomponents/reusables';

interface CouponsScreenProps {
  onHydrate;
  currentState;
  coupons: Array<CouponModel>;
  deleteCoupon;
}

const CouponsScreen: React.FC<CouponsScreenProps> = ({ coupons, deleteCoupon, currentState }) => {
  const [coupon, setCoupon] = useState<any>(null);
  const ACCESS = getAccess(currentState);

  const onAddCoupon = () => {
    setCoupon(initialCoupon);
  };

  const couponItemActions: Array<ItemActionModel> = [
    {
      label: 'BUTTON.EDIT',
      eventName: 'editItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.COUPON.EDIT, currentState),
      onClick: setCoupon,
    },
    {
      label: 'BUTTON.DELETE',
      eventName: 'deleteItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.COUPON.DELETE, currentState),
      onClick: (row) => {
        dialog.confirm({
          message: 'MESSAGE.DELETE_WARNING',
          onPress: async () => {
            await deleteCoupon(row.id);
          },
        });
      },
    },
  ];

  return (
    <IonPageWrapper>
      <Header title="SCREEN.COUPONS.TITLE" />
      <IonContent>
        <TableView2
          data={coupons}
          tableConfig={COUPON_TABLE_CONFIG}
          TABLE={COUPON_TABLE()}
          itemActions={couponItemActions}
        />
      </IonContent>
      <FabButton onClick={onAddCoupon} className={accessHide(ACCESS.ACTION.SETTING.COUPON.CREATE)} />
      <CouponEditModal
        show={!!coupon}
        currentState={currentState}
        coupon={coupon}
        onClose={() => setCoupon(null)}
      />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  coupons: state.factory.factory.coupons,
});

const mapDispatchToProps = {
  onHydrate: () => factoryActions.fetchCoupons(),
  updateCoupon: factoryActions.saveCoupon,
  deleteCoupon: factoryActions.deleteCoupon,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(CouponsScreen));
